import { useState } from 'react';
import * as St from '../SgBackgroundDesign/SgBackgroundDesign.styled';
import { CustomRatioImage } from '@/components/image/CustomRatioImage';
import CustomBlockButton from '@/components/button/CustomBlockButton';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';
import { useChangeUserPagePageFontMutation } from '@/hooks/ReactQuery/UserPageReactQuery/UserPageReactQuery';
import { ProBadge, ProUpsell, usePagePro } from '@/views/mypage/components/FdSubscription/proPlan';
import { PAGE_FONTS, useFonts } from '../../premiumDesign';

/** 페이지 전체 폰트 (기본 외에는 슈룩 Pro) */
export function SgFontDesign({ onRefreshPreviewViewer }) {
    useFonts();
    const userPage = useUserPageContextValueHook()?.userPage;
    const isPro = usePagePro();
    const changePageFontMutation = useChangeUserPagePageFontMutation();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [pageFont, setPageFont] = useState(userPage?.pageFont || 'DEFAULT');

    const handleApply = () => {
        changePageFontMutation.mutate({ body: { id: userPage?.id, pageFont } }, {
            onSuccess: () => onRefreshPreviewViewer(),
        });
    };

    return (
        <St.Container>
            <St.HeaderWrapper>
                <div className='headerBox' onClick={() => setDropdownOpen(!dropdownOpen)}>
                    <div className='title flex items-center gap-1.5'>페이지 폰트 <ProBadge /></div>
                    <div className='icon'>
                        <CustomRatioImage>
                            <CustomRatioImage.Image src={dropdownOpen ? '/assets/icons/expandLess_000000.svg' : '/assets/icons/expandMore_000000.svg'} />
                        </CustomRatioImage>
                    </div>
                </div>
            </St.HeaderWrapper>
            {dropdownOpen &&
                <>
                    {!isPro &&
                        <div className="px-5 pb-3">
                            <ProUpsell title="페이지 폰트" description="페이지 전체 글씨를 원하는 폰트로 바꿀 수 있어요. 텍스트 모듈·사진 설명 폰트도 Pro 에서 쓸 수 있어요." />
                        </div>
                    }
                    <div className="grid grid-cols-2 gap-2 px-5">
                        {PAGE_FONTS.map(font => {
                            const locked = !isPro && font.value !== 'DEFAULT';
                            const active = pageFont === font.value;
                            return (
                                <button
                                    key={font.value}
                                    type="button"
                                    disabled={locked}
                                    onClick={() => setPageFont(font.value)}
                                    className={`rounded-xl px-3 py-3 text-left ring-1 transition ${active ? 'bg-gray-900 text-white ring-gray-900' : 'bg-white text-gray-800 ring-gray-200 hover:bg-gray-50'} ${locked ? 'cursor-not-allowed opacity-40' : ''}`}
                                >
                                    <span className="block text-[11px] font-semibold opacity-70">{font.label}</span>
                                    <span className="mt-0.5 block truncate text-[17px]" style={font.family ? { fontFamily: font.family } : undefined}>안녕하세요 슈룩</span>
                                </button>
                            );
                        })}
                    </div>
                    <St.FooterWrapper>
                        <CustomBlockButton type='button' disabled={!isPro && pageFont !== 'DEFAULT'} onClick={handleApply}>
                            적용
                        </CustomBlockButton>
                    </St.FooterWrapper>
                </>
            }
        </St.Container>
    );
}
